const routes = [
    // For marketing
    {
        path: '/unsubscribe-email',
        name: 'unsubscribe-email',
        component: () => import('source/pages/UnsubscribeEmail.vue'),
        meta: {
            title: 'Unsubscribe - HQZen',
            loginRequired: false
        },
    },
    // For Email Subscription
    {
        path: '/unsubscribe-email/:token',
        name: 'unsubscribe-email',
        component: () => import('source/pages/UnsubscribeEmail.vue'),
        meta: {
            title: 'Unsubscribe - HQZen',
            loginRequired: false
        },
    }
];

export default routes;
